// extracted by mini-css-extract-plugin
export default {"logoContainer":"SideNav_logoContainer__4Skvs","logoIcon":"SideNav_logoIcon__d0S8-","logoText":"SideNav_logoText__UeTKF","collapsed":"SideNav_collapsed__oGTLr"};